/** The name, or the name with the lowest number after it that no other record in the account holds. */
export function uniqueName(name: string, taken: ReadonlySet<string>): string {
  if (!taken.has(name)) return name;

  let number = 2;
  while (taken.has(`${name} ${number}`)) number++;
  return `${name} ${number}`;
}
